import { gql } from '@apollo/client'

const QUERY_MERCHANT_DISCOUNTS = gql`
  query getDiscounts(
    $page: Int!
    $search: String
    $merchantId: ID!
    $filter: DiscountFilter!
    $type: DiscountTrigger!
  ) {
    getMerchantDiscounts(
      merchantId: $merchantId
      page: $page
      filter: $filter
      type: $type
      search: $search
    ) {
      pageSize
      pageNumber
      totalPages
      totalEntries
      discounts {
        id
        code
        type
        value
        target
        trigger
        quantity
        end_date
        store_ids
        start_date
        description
        usage_count
        minimum_value
      }
    }
  }
`

const QUERY_MERCHANT_CUSTOMERS = gql`
  query merchantCustomers($merchantId: uuid!) {
    orders(
      limit: 100
      where: {
        merchant_id: { _eq: $merchantId }
        details_disclosed: { _eq: true }
      }
      order_by: { inserted_at: desc }
    ) {
      first_name: customer_details(path: "first_name")
      last_name: customer_details(path: "last_name")
      email: customer_details(path: "email")
      contact_number: customer_details(path: "contact_num")
      zip: customer_details(path: "address.zip")
      city: customer_details(path: "address.city")
      address: customer_details(path: "address.line_2")
    }
    customers(
      limit: 100
      where: { merchant_id: { _eq: $merchantId } }
      order_by: { inserted_at: desc }
    ) {
      merchant_id
      first_name
      last_name
      email
      birthdate
      inserted_at
      stamps: stamps_aggregate {
        aggregate {
          count
        }
      }
      redeemed_cards: customer_loyalty_cards_aggregate(
        where: { redeemed_at: { _is_null: false } }
      ) {
        aggregate {
          count
        }
      }
      orders: orders_aggregate {
        aggregate {
          sum {
            total
          }
        }
      }
    }
  }
`

const QUERY_MERCHANT_CONNECTED_CARDS = gql`
  query merchantConnectedStripeCards($merchantSlug: String) {
    cards: merchantConnectedStripeCards(merchantSlug: $merchantSlug) {
      id
      last4
      expMonth
      expYear
      defaultSource
    }
  }
`

const QUERY_MERCHANT_STRIPE_ACCOUNT_SESSION = gql`
  query getMerchantStripeAccountSession($merchantSlug: String!) {
    getMerchantStripeAccountSession(merchantSlug: $merchantSlug) {
      account
      clientSecret
      publicKey
      expiresAt
      livemode
      object
    }
  }
`

export {
  QUERY_MERCHANT_CUSTOMERS,
  QUERY_MERCHANT_DISCOUNTS,
  QUERY_MERCHANT_CONNECTED_CARDS,
  QUERY_MERCHANT_STRIPE_ACCOUNT_SESSION
}
